import { useParams } from "react-router-dom";
import {
  OrderByType,
  useGenericAPI,
  useSingleGenericAPI,
} from "../../../utils/genericAPI/useGenericAPI";
import { useAuth } from "../../auth/hooks";
import { Client, ClientExtend, ClientPatch } from "../types/clients.types";
import {
  BASE_URL_CLIENT,
  BASE_URL_CLIENT_EXTEND,
} from "../services/clientsAPI";
import { useWallets } from "../../wallet/hooks/useWallet";

export const useClients = (config?: {
  pageSize?: number;
  orderBy?: OrderByType<Client>;
}) => {
  const { setHeaderAuthToRequest, organizationIdUser } = useAuth();

  setHeaderAuthToRequest();

  const { getAllQuery, createNew: createNewClient } = useGenericAPI<
    Client,
    ClientPatch,
    ClientPatch
  >({
    baseURL: BASE_URL_CLIENT,
    APIname: "clients-" + organizationIdUser,
    pageSize: config?.pageSize,
    orderBy: config?.orderBy,
  });

  return {
    allClientsQuery: { ...getAllQuery },
    createNewClientQuery: {
      ...createNewClient,
    },
  };
};

export const useClientsExtend = (config?: {
  pageSize?: number;
  orderBy?: OrderByType<ClientExtend>;
}) => {
  const { setHeaderAuthToRequest, organizationIdUser } = useAuth();

  setHeaderAuthToRequest();

  const { getAllQuery, createNew: createNewClient } = useGenericAPI<
    ClientExtend,
    Partial<ClientExtend>,
    Partial<ClientExtend>
  >({
    baseURL: BASE_URL_CLIENT_EXTEND,
    APIname: "clientsExtend-" + organizationIdUser,
    pageSize: config?.pageSize,
    orderBy: config?.orderBy,
  });

  return {
    allClientsQuery: { ...getAllQuery },
    createNewClientQuery: {
      ...createNewClient,
    },
  };
};

export const useSingleClient = (clientId?: string) => {
  const { clientId: idUrl } = useParams<{ clientId: string }>();

  const clientIdFound = clientId || idUrl;
  if (!clientId && !idUrl) {
    console.error("useSingleClient: clientId is required");
  }

  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  const { singleQuery, deleteQuery, patchQuery } = useSingleGenericAPI<
    Client,
    ClientPatch
  >({
    baseURL: BASE_URL_CLIENT,
    APIname: "clients",
    id: clientId || idUrl,
  });



  return {
    clientId: clientIdFound,
    singleClientQuery: singleQuery,
    deleteClientQuery: deleteQuery,
    patchClientQuery: patchQuery,

  };
};

export const useSingleClientExtend = (userOrgaId?: string) => {


  const { setHeaderAuthToRequest, organizationIdUser } = useAuth();
  setHeaderAuthToRequest();

  const {userOrgaId:userOrgaIdURL} = useParams<{ userOrgaId: string }>();
  const userOrgaIdFound = userOrgaId || userOrgaIdURL;
  if (!userOrgaId && !userOrgaIdURL) {
    console.error("useSingleClientExtend: userOrgaId is required");
  }
  const { singleQuery, } = useSingleGenericAPI<
    ClientExtend,
    Partial<ClientExtend>
  >({
    baseURL: BASE_URL_CLIENT_EXTEND,
    APIname: "clientsExtend-"+organizationIdUser,
    id: userOrgaIdFound,
  });

  const { allWalletsQuery } = useWallets({
    preFilters: { wallet_user_orga_id: `=${userOrgaIdFound}` },
  });

  return {
    singleClientQuery: singleQuery,
    userOrgaIdFound,
    allWalletsQuery 
  
  };
};
